import { Component, Output, EventEmitter } from "@angular/core";
import { TimeProvider } from "../../providers/time/time";
import { FormGroup, FormBuilder } from "@angular/forms";
import { ApplicationApiProvider } from "../../providers/application-api/application-api";
import { DemoProvider } from "../../providers/demo/demo";

import * as moment from "moment";
import { TimeParams } from "../../models/TimeParams";
import { BehaviorSubject } from "rxjs";
import { NavParams, ViewController } from "ionic-angular";
import { EntitiesProvider } from "../../providers/entities/entities";

@Component({
  selector: "time-control",
  templateUrl: "time-control.html",
})
export class TimeControlComponent {
  timeRange = 30;
  customTimeForm: FormGroup;
  navType: string;
  demo = false;
  changes: BehaviorSubject<TimeParams>;

  constructor(
    private viewCtrl: ViewController,
    private time: TimeProvider,
    private fb: FormBuilder,
    public navParams: NavParams,
    private appApi: ApplicationApiProvider,
    private entitiesProvider: EntitiesProvider,
    private demop: DemoProvider
  ) {
    this.changes = this.navParams.get("changes");
    this.navType = this.entitiesProvider.currentEntity.getType();
    this.demo = this.demop.demoMode;
    this.timeRange = 7;
    this.customTimeForm = this.fb.group({
      from: moment().add(-7, "days").format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
    });
  }

  setTimeRange(value: any): void {
    const selectedTime =
      this.time.timeParse[
        this.time.timeParse.findIndex((t) => t.days == value)
      ];
    this.timeRange = value;
    this.customTimeForm.get("from").setValue(
      moment()
        .add(
          -selectedTime.momentValue,
          selectedTime.momentType as moment.DurationInputArg2
        )
        .format("YYYY-MM-DD")
    );
    this.customTimeForm.get("to").setValue(moment().format("YYYY-MM-DD"));
  }

  changedFrom(event) {
    // tslint:disable-next-line:radix
    let eventDate = new Date(event.year, parseInt(event.month) - 1, event.day);
    let eventValue = moment(eventDate);
    this.validationInputFrom(eventValue);
  }

  changedTo(event) {
    // tslint:disable-next-line:radix
    let eventDate = new Date(event.year, parseInt(event.month) - 1, event.day);
    let eventValue = moment(eventDate);

    this.validationInputTo(eventValue);
  }

  validationInputFrom(value: any) {
    if (!value.isBefore(moment(this.customTimeForm.get("to").value))) {
      this.customTimeForm
        .get("to")
        .setValue(
          moment(this.customTimeForm.get("from").value)
            .add(1, "d")
            .format("YYYY-MM-DD")
        );
    }
  }

  validationInputTo(value: any) {
    if (!moment(this.customTimeForm.get("from").value).isBefore(value)) {
      this.customTimeForm
        .get("from")
        .setValue(
          moment(this.customTimeForm.get("to").value)
            .add(-1, "d")
            .format("YYYY-MM-DD")
        );
    }
  }

  applyCustomTime(): void {
    if (this.customTimeForm.valid) {
      let timeParams = this.time.getTimeParamsForCustomRange(
        this.customTimeForm.value.from,
        this.customTimeForm.value.to
      );
      this.timeRange = timeParams.range;
      this.changes.next(timeParams);
      setTimeout(() => {
        this.viewCtrl.dismiss();
      });
    } else {
      this.appApi.showToast(
        "Time control is not valid, please check it and try again"
      );
    }
  }

  close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/time-control/time-control.ts